import { Animal } from '../types/Animal';

export class AnimalService {
  private static sheetsUrl = process.env.REACT_APP_SHEETS_URL || '';

  static async fetchAnimals(): Promise<Animal[]> {
    try {
      // Add cache-busting timestamp to force fresh data
      const timestamp = Date.now();
      const urlWithTimestamp = `${this.sheetsUrl}&cachebust=${timestamp}`;
      console.log('Fetching from:', urlWithTimestamp);
      
      const response = await fetch(urlWithTimestamp, {
        cache: 'no-cache',
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      });
      const csvText = await response.text();
      console.log('Raw CSV data:', csvText);
      const animals = this.parseCsvToAnimals(csvText);
      console.log('Total animals parsed:', animals.length);
      return animals;
    } catch (error) {
      console.error('Error fetching animals:', error);
      return this.getMockData();
    }
  }

  private static parseCsvToAnimals(csvText: string): Animal[] {
    const lines = csvText.split('\n');
    const headers = lines[0].split(',').map(h => h.trim().replace(/"/g, ''));
    
    return lines.slice(1)
      .filter(line => line.trim())
      .map((line, index) => {
        const values = this.parseCsvLine(line);
        const rowData: any = {};
        
        headers.forEach((header, i) => {
          rowData[header] = values[i] ? values[i].replace(/"/g, '') : '';
        });

        // Debug logging
        console.log('Parsed animal:', {
          name: rowData["Animal's Name"],
          photos: rowData['Photos'],
          headers: headers
        });

        const photosString = rowData['Photos'] || '';
        const photos = photosString ? 
          photosString.split(',')
            .map((url: string) => url.trim())
            .filter((url: string) => url.length > 0) : 
          [];

        return {
          id: `animal-${index}`,
          timestamp: rowData['Timestamp'] || '',
          name: rowData["Animal's Name"] || '',
          species: rowData['Species'] || '',
          breed: rowData['Breed'] || '',
          age: rowData['Age'] || '',
          tags: rowData['Tags'] || '',
          story: rowData['Story'] || '',
          color: rowData['Color'] || '',
          sex: rowData['Sex'] || '',
          photos: photos
        };
      });
  }


  private static parseCsvLine(line: string): string[] {
    const result = [];
    let current = '';
    let inQuotes = false;
    
    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      
      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        result.push(current.trim());
        current = '';
      } else {
        current += char;
      }
    }
    
    result.push(current.trim());
    return result;
  }

  private static getMockData(): Animal[] {
    return [
      {
        id: 'hellcat',
        timestamp: '2025-07-27 17:48',
        name: 'Hellcat',
        species: 'Cat',
        breed: 'Domestic Shorthair',
        age: '2 years',
        tags: 'Playful, Energetic',
        story: 'A beautiful black cat with stunning green eyes. Loves to play and explore.',
        color: 'Black',
        sex: 'Female',
        photos: ['https://drive.google.com/file/d/1example1/view']
      },
      {
        id: 'oreo',
        timestamp: '2025-07-27 17:59',
        name: 'Oreo',
        species: 'Cat',
        breed: 'Domestic Shorthair',
        age: '1 year',
        tags: 'Sweet, Cuddly',
        story: 'A sweet black and white cat who loves cuddles and treats.',
        color: 'Black and White',
        sex: 'Male',
        photos: ['https://drive.google.com/file/d/1example2/view', 'https://drive.google.com/file/d/1example3/view']
      }
    ];
  }
}